import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

import { primaryContentLanguageCodeSelector } from "@skilitics/nautilus-core-designer-data";

import { activeContentLanguageCodeSelector } from "../state/index.ts";

export const usePrimaryLanguageCode = () => {
  return useSelector(primaryContentLanguageCodeSelector);
};

const activeLanguageIsPrimaryLanguageSelector = createSelector(
  [primaryContentLanguageCodeSelector, activeContentLanguageCodeSelector],
  (primaryLanguageCode, activeLanguageCode) => primaryLanguageCode === activeLanguageCode,
);

// Simple hook to check if the primary language is the same as the active language
export const useIsPrimaryLanguage = () => {
  return useSelector(activeLanguageIsPrimaryLanguageSelector);
};
